import { VictoryLabel } from 'victory';

interface DataLabelProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scale?: any;
  x: string | number;
  y: string | number;
  text: string[];
}

function DataLabel(props: DataLabelProps) {
  const x = props.scale.x(props.x);
  const y = props.scale.y(props.y);

  const baseStyle = {
    fill: '#191919',
    fontWeight: 600,
    textAnchor: 'start',
    fontSize: 5,
    fontFamily: 'inherit',
  };

  return (
    <VictoryLabel
      inline
      {...props}
      x={x}
      y={y}
      backgroundStyle={
        {
          fill: 'white',
          rx: 2,
          ry: 2,
        } as React.CSSProperties
      }
      backgroundPadding={{
        top: 1,
        bottom: 3,
        left: 2,
        right: 8,
      }}
      style={[
        baseStyle,
        {
          ...baseStyle,
          fontWeight: 'none',
        },
      ]}
    />
  );
}

DataLabel.displayName = 'DataLabel';
export { DataLabel };
